import {
    IMAGE_LOADING, IMAGE_LOADED, IMAGE_ERROR, DEFAULT_MARK_SIZE } from '../constants';
import { getCachedImage, getImageLoadingState } from '../imageCache';
import { imageLoadingPolygonStyle, imageErrorPolygonStyle } from './static';
import { Fill } from 'ol/style';

import { asColorLike } from 'ol/colorlike.js';
import { hexToRGB } from './styleUtils';

function getMarkFillStyle(graphicFill) {
  
    const mark = graphicFill.graphic.mark;
    const size = graphicFill.graphic && graphicFill.graphic.size ? graphicFill.graphic.size : DEFAULT_MARK_SIZE;
    const rotation = graphicFill.graphic.rotation==null?0: Number(graphicFill.graphic.rotation);

    switch(mark.wellknownname){
        case 'square': return calculateSquare(mark, size, rotation);
        case 'circle': return calculateCircle(mark, size, rotation);
        case 'triangle': return calculateTriangle(mark, size, rotation);
        case 'star': return calculateStar(mark, size, rotation);
        case 'cross': return calculateCross(mark, size, rotation);
        case 'x': return calculateX(mark, size, rotation);
        case 'shape://backslash': return calculateShapeBackslash(mark, size, rotation);
        case 'shape://slash': return calculateShapeSlash(mark, size, rotation);
        case 'shape://arrow': return calculateShapeArrow(mark, size, rotation);
        case 'arrow': return calculateShapeArrow(mark, size, rotation);
        default: return calculateCircle(mark, size, rotation);
    }
}

function calculateShapeBackslash(mark, size, rotation){
    const fill = new Fill();

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    var pattern = (function (canvas, ctx, size, mark, rotation) {
        const styling = mark.stroke && mark.stroke.styling;
        var color = 'black';
        var lineWidth = 1;

        if(styling && styling.stroke){
            color = styling.stroke;
        }

        if(styling && styling.strokeWidth){
            lineWidth = Number(styling.strokeWidth);
        }

        canvas.width = Number(size);
        canvas.height = Number(size);

        var width = canvas.width;
        var height = canvas.height;

        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(width, height);
        ctx.closePath();
        ctx.lineWidth= lineWidth;
        ctx.strokeStyle= color;
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(0, height);
        ctx.lineTo(1, height);
        ctx.closePath();
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(width, 0);
        ctx.lineTo(width, 1);
        ctx.closePath();
        ctx.stroke();

        var svgNamespace = "http://www.w3.org/2000/svg";
        var matrix = document.createElementNS(svgNamespace, "g").getCTM();
        var ptn = ctx.createPattern(canvas, 'repeat');
        ptn.setTransform(matrix.rotate(rotation));

        return ptn;

    })(canvas, ctx, size, mark, rotation);
    
    fill.setColor(pattern);
    return fill;
}

function calculateShapeSlash(mark, size, rotation){
    const fill = new Fill();

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    var pattern = (function (canvas, ctx, size, mark, rotation) {
        const styling = mark.stroke && mark.stroke.styling;
        var color = 'black';
        var lineWidth = 1;

        if(styling && styling.stroke){
            color = styling.stroke;
        }

        if(styling && styling.strokeWidth){
            lineWidth = Number(styling.strokeWidth);
        }

        canvas.width = Number(size);
        canvas.height = Number(size);

        var width = canvas.width;
        var height = canvas.height;

        ctx.beginPath();
        ctx.moveTo(width, 0);
        ctx.lineTo(0, height);
        ctx.closePath();
        ctx.lineWidth= lineWidth;
        ctx.strokeStyle= color;
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(width, height);
        ctx.lineTo(width, height - 0.5);
        ctx.closePath();
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(0, 0.5);
        ctx.closePath();
        ctx.stroke();

        var svgNamespace = "http://www.w3.org/2000/svg";
        var matrix = document.createElementNS(svgNamespace, "g").getCTM();
        var ptn = ctx.createPattern(canvas, 'repeat');
        ptn.setTransform(matrix.rotate(rotation));

        return ptn;

    })(canvas, ctx, size, mark, rotation);
    
    fill.setColor(pattern);
    return fill;
}

function calculateShapeArrow(mark, size, rotation) {
    const fill = new Fill();

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    var pattern = (function (canvas, ctx, size, mark, rotation) {
        const styling = mark.stroke && mark.stroke.styling;
        var color = 'black';
        var lineWidth = 1;

        if (styling && styling.stroke) {
            color = styling.stroke;
        }

        if (styling && styling.strokeWidth) {
            lineWidth = Number(styling.strokeWidth);
        }

        canvas.width = Number(size);
        canvas.height = Number(size);

        var width = canvas.width;
        var height = canvas.height;

        ctx.beginPath();
        ctx.moveTo(width/3, 0);
        ctx.lineTo(width, height / 2);
        ctx.lineTo(width/3, height);
        ctx.closePath();
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = color;
        ctx.stroke();

        var svgNamespace = "http://www.w3.org/2000/svg";
        var matrix = document.createElementNS(svgNamespace, "g").getCTM();
        var ptn = ctx.createPattern(canvas, 'repeat');
        ptn.setTransform(matrix.rotate(rotation));

        return ptn;

    })(canvas, ctx, size, mark, rotation);

    fill.setColor(pattern);
    return fill;
}

function calculateSquare(mark, size, rotation){
    const fill = new Fill();

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    var pattern = (function (canvas, ctx, size, mark, rotation) {
        const stylingStroke = mark.stroke && mark.stroke.styling;
        const stylingFill = mark.fill && mark.fill.styling;
        var strokeColor = 'black';
        var fillColor = 'white';
        var lineWidth = 1;

        if (stylingStroke && stylingStroke.stroke) {
            var strokeOpacity = stylingStroke.strokeOpacity == null ? 1 : Number(stylingStroke.strokeOpacity);
            strokeColor = hexToRGB(stylingStroke.stroke, strokeOpacity);
        }

        if (stylingStroke && stylingStroke.strokeWidth){
            lineWidth = Number(stylingStroke.strokeWidth);
        }

        if (stylingFill && stylingFill.fill) {
            var fillOpacity = stylingFill.fillOpacity == null ? 1 : Number(stylingFill.fillOpacity);
            fillColor = hexToRGB(stylingFill.fill, fillOpacity) ;
        }

        canvas.width = Number(size);
        canvas.height = Number(size);
        
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(canvas.width, 0);
        ctx.lineTo(canvas.width, canvas.height);
        ctx.lineTo(0, canvas.height);
        ctx.lineTo(0, 0);
        ctx.closePath();
   
        ctx.fillStyle = fillColor;
        ctx.fill();
        ctx.strokeStyle = strokeColor;
        ctx.lineWidth = lineWidth;
        ctx.stroke();

        var svgNamespace = "http://www.w3.org/2000/svg";
        var matrix = document.createElementNS(svgNamespace, "g").getCTM();
        var ptn = ctx.createPattern(canvas, 'repeat');
        ptn.setTransform(matrix.rotate(rotation));

        return ptn;

    })(canvas, ctx, size, mark, rotation);
    
    fill.setColor(pattern);
    return fill;
}

function calculateCircle(mark, size, rotation){
    const fill = new Fill();

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    var pattern = (function (canvas, ctx, size, mark, rotation) {
        const stylingStroke = mark.stroke && mark.stroke.styling;
        const stylingFill = mark.fill && mark.fill.styling;
        var strokeColor = 'black';
        var fillColor = 'white';
        var lineWidth = 1;

        if (stylingStroke && stylingStroke.stroke) {
            var strokeOpacity = stylingStroke.strokeOpacity == null ? 1 : Number(stylingStroke.strokeOpacity);
            strokeColor = hexToRGB(stylingStroke.stroke, strokeOpacity);
        }

        if (stylingStroke && stylingStroke.strokeWidth) {
            lineWidth = Number(stylingStroke.strokeWidth);
        }

        if (stylingFill && stylingFill.fill) {
            var fillOpacity = stylingFill.fillOpacity == null ? 1 : Number(stylingFill.fillOpacity);
            fillColor = hexToRGB(stylingFill.fill, fillOpacity);
        }

        canvas.width = Number(size);
        canvas.height = Number(size);

        var centerX = canvas.width / 2;
        var centerY = canvas.height / 2;
        var radius = canvas.width / 2 - (lineWidth / 2);

        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
        ctx.fillStyle = fillColor;
        ctx.fill();
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = strokeColor;
        ctx.stroke();

        var svgNamespace = "http://www.w3.org/2000/svg";
        var matrix = document.createElementNS(svgNamespace, "g").getCTM();
        var ptn = ctx.createPattern(canvas, 'repeat');
        ptn.setTransform(matrix.rotate(rotation));

        return ptn;

    })(canvas, ctx, size, mark, rotation);
    
    fill.setColor(pattern);
    return fill;
}

function calculateTriangle(mark, size, rotation){
    const fill = new Fill();

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    var pattern = (function (canvas, ctx, size, mark, rotation ) {
        const stylingStroke = mark.stroke && mark.stroke.styling;
        const stylingFill = mark.fill && mark.fill.styling;
        var strokeColor = 'black';
        var fillColor = 'white';
        var lineWidth = 1;

        if (stylingStroke && stylingStroke.stroke) {
            var strokeOpacity = stylingStroke.strokeOpacity == null ? 1 : Number(stylingStroke.strokeOpacity);
            strokeColor = hexToRGB(stylingStroke.stroke, strokeOpacity);
        }

        if (stylingStroke && stylingStroke.strokeWidth) {
            lineWidth = Number(stylingStroke.strokeWidth);
        }

        if (stylingFill && stylingFill.fill) {
            var fillOpacity = stylingFill.fillOpacity == null ? 1 : Number(stylingFill.fillOpacity);
            fillColor = hexToRGB(stylingFill.fill, fillOpacity);
        }

        canvas.width = Number(size);
        canvas.height = Number(size);

        ctx.beginPath();
        ctx.moveTo(canvas.width / 2, 4);
        ctx.lineTo(canvas.width - 2 , canvas.height - 2);
        ctx.lineTo(2, canvas.height - 2);
        ctx.lineTo(canvas.width / 2, 4);
        ctx.closePath();

        ctx.fillStyle = fillColor;
        ctx.fill();
        ctx.strokeStyle = strokeColor;
        ctx.lineWidth = lineWidth;
        ctx.stroke();

        var svgNamespace = "http://www.w3.org/2000/svg";
        var matrix = document.createElementNS(svgNamespace, "g").getCTM();
        var ptn = ctx.createPattern(canvas, 'repeat');
        ptn.setTransform(matrix.rotate(rotation));

        return ptn;
    })(canvas, ctx, size, mark, rotation);

    fill.setColor(pattern);
    return fill;
}

function calculateStar(mark, size, rotation){
   
    const fill = new Fill();

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    var pattern = (function (canvas, ctx, size, mark, rotation) {
      
        const stylingStroke = mark.stroke && mark.stroke.styling;
        const stylingFill = mark.fill && mark.fill.styling;
        var strokeColor = 'black';
        var fillColor = 'white';
        var lineWidth = 1;

        if (stylingStroke && stylingStroke.stroke) {
            var strokeOpacity = stylingStroke.strokeOpacity == null ? 1 : Number(stylingStroke.strokeOpacity);
            strokeColor = strokeOpacity == 1 ? stylingStroke.stroke: hexToRGB(stylingStroke.stroke, strokeOpacity);
        }

        if (stylingStroke && stylingStroke.strokeWidth) {
            lineWidth = Number(stylingStroke.strokeWidth);
        }

        if (stylingFill && stylingFill.fill) {
            var fillOpacity = stylingFill.fillOpacity == null ? 1 : Number(stylingFill.fillOpacity);
            fillColor = fillOpacity == 1 ? stylingFill.fill: hexToRGB(stylingFill.fill, fillOpacity);
        }

        canvas.width = Number(size);
        canvas.height = Number(size);

        const spikes = 5;
        const outerRadius = canvas.height/2;
        const innerRadius = canvas.height/4;
        const cx = canvas.height/2, cy = canvas.height/2;

        var rot = Math.PI / 2 * 3;
        var x = cx;
        var y = cy;
        var step = Math.PI / spikes;

        ctx.beginPath();
        ctx.moveTo(cx, cy - outerRadius);
        for (var i = 0; i < spikes; i++) {
            x = cx + Math.cos(rot) * outerRadius;
            y = cy + Math.sin(rot) * outerRadius;
            ctx.lineTo(x, y)
            rot += step

            x = cx + Math.cos(rot) * innerRadius;
            y = cy + Math.sin(rot) * innerRadius;
            ctx.lineTo(x, y)
            rot += step
        }
        ctx.lineTo(cx, cy - outerRadius);
        ctx.closePath();
        ctx.strokeStyle = asColorLike(strokeColor);
        ctx.lineWidth = lineWidth;
        ctx.stroke();
        ctx.fillStyle = asColorLike(fillColor);
        ctx.fill();

        var svgNamespace = "http://www.w3.org/2000/svg";
        var matrix = document.createElementNS(svgNamespace, "g").getCTM();
        var ptn = ctx.createPattern(canvas, 'repeat');
        ptn.setTransform(matrix.rotate(rotation));

        return ptn;

    })(canvas, ctx, size, mark, rotation);
    
    fill.setColor(pattern);
    return fill;
}

function calculateCross(mark, size, rotation) {

    const fill = new Fill();

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    var pattern = (function (canvas, ctx, size, mark, rotation) {
        const stylingStroke = mark.stroke && mark.stroke.styling;
        const stylingFill = mark.fill && mark.fill.styling;
        var strokeColor = 'black';
        var fillColor = 'white';
        var lineWidth = 1;

        if (stylingStroke && stylingStroke.stroke) {
            var strokeOpacity = stylingStroke.strokeOpacity == null ? 1 : Number(stylingStroke.strokeOpacity);
            strokeColor = hexToRGB(stylingStroke.stroke, strokeOpacity);
        }

        if (stylingStroke && stylingStroke.strokeWidth) {
            lineWidth = Number(stylingStroke.strokeWidth);
        }

        if (stylingFill && stylingFill.fill) {
            var fillOpacity = stylingFill.fillOpacity == null ? 1 : Number(stylingFill.fillOpacity);
            fillColor = hexToRGB(stylingFill.fill, fillOpacity);
        }

        canvas.width = Number(size);
        canvas.height = Number(size);

        ctx.beginPath();
        ctx.moveTo((canvas.width / 5) * 2, 0);
        ctx.lineTo((canvas.width / 5) * 3, 0);
        ctx.lineTo((canvas.width / 5) * 3, (canvas.height / 5) * 2);
        ctx.lineTo(canvas.width, (canvas.height / 5) * 2);
        ctx.lineTo(canvas.width, (canvas.height / 5) * 3);
        ctx.lineTo((canvas.width / 5) * 3, (canvas.height / 5) * 3);
        ctx.lineTo((canvas.width / 5) * 3, canvas.height);
        ctx.lineTo((canvas.width / 5) * 2, canvas.height);
        ctx.lineTo((canvas.width / 5) * 2, (canvas.height / 5) * 3);
        ctx.lineTo(0, (canvas.height / 5) * 3);
        ctx.lineTo(0, (canvas.height / 5) * 2);
        ctx.lineTo((canvas.width / 5) * 2, (canvas.height / 5) * 2);
        ctx.lineTo((canvas.width / 5) * 2, 0);
        ctx.closePath();
        ctx.fillStyle = fillColor;
        ctx.fill();
        ctx.strokeStyle = strokeColor;
        ctx.lineWidth = lineWidth;
        ctx.stroke();

        var svgNamespace = "http://www.w3.org/2000/svg";
        var matrix = document.createElementNS(svgNamespace, "g").getCTM();
        var ptn = ctx.createPattern(canvas, 'repeat');
        ptn.setTransform(matrix.rotate(rotation));

        return ptn;
    })(canvas, ctx, size, mark, rotation);
    
    fill.setColor(pattern);
    return fill;
}

function calculateX(mark, size, rotation){
    const fill = new Fill();

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    var pattern = (function (canvas, ctx, size, mark, rotation) {
        const stylingStroke = mark.stroke && mark.stroke.styling;
        const stylingFill = mark.fill && mark.fill.styling;
        var strokeColor = 'black';
        var fillColor = 'white';
        var lineWidth = 1;

        if (stylingStroke && stylingStroke.stroke) {
            var strokeOpacity = stylingStroke.strokeOpacity == null ? 1 : Number(stylingStroke.strokeOpacity);
            strokeColor = hexToRGB(stylingStroke.stroke, strokeOpacity);
        }

        if (stylingStroke && stylingStroke.strokeWidth) {
            lineWidth = Number(stylingStroke.strokeWidth);
        }

        if (stylingFill && stylingFill.fill) {
            var fillOpacity = stylingFill.fillOpacity == null ? 1 : Number(stylingFill.fillOpacity);
            fillColor = hexToRGB(stylingFill.fill, fillOpacity);
        }

        canvas.width = Number(size);
        canvas.height = Number(size);

        var newWidth = Number(size) * 0.8;
        var buffer = Number(size) * 0.1;
        var cornerWidth = (newWidth / 4) / Math.sqrt(2);

        ctx.beginPath();
        ctx.moveTo(buffer + cornerWidth, buffer);
        ctx.lineTo(buffer + newWidth / 2, buffer + newWidth / 3);
        ctx.lineTo(buffer + newWidth - cornerWidth, buffer);
        ctx.lineTo(buffer + newWidth, buffer + cornerWidth);
        ctx.lineTo((newWidth / 3) * 2 + buffer, newWidth / 2 + buffer);
        ctx.lineTo(buffer + newWidth, buffer + newWidth - cornerWidth);
        ctx.lineTo(buffer + newWidth - cornerWidth, buffer + newWidth);
        ctx.lineTo(newWidth / 2 + buffer, (newWidth / 3) * 2 + buffer);
        ctx.lineTo(buffer + cornerWidth, buffer + newWidth);
        ctx.lineTo(buffer, buffer + newWidth - cornerWidth);
        ctx.lineTo(newWidth / 3 + buffer, newWidth / 2 + buffer);
        ctx.lineTo(buffer, buffer + cornerWidth);
        ctx.lineTo(buffer + cornerWidth, buffer);
        ctx.closePath();
        ctx.fillStyle = fillColor;
        ctx.fill();
        ctx.strokeStyle = strokeColor;
        ctx.lineWidth = lineWidth;
        ctx.stroke();

 
        var svgNamespace = "http://www.w3.org/2000/svg";
        var matrix = document.createElementNS(svgNamespace, "g").getCTM();
        var ptn = ctx.createPattern(canvas, 'repeat');
        ptn.setTransform(matrix.rotate(rotation));

        return ptn;

    })(canvas, ctx, size, mark, rotation);
    
    fill.setColor(pattern);
    return fill;
}

function getExternalGraphicFill(graphicFill) {
    const { graphic } = graphicFill;
    const fillImageUrl = graphic.externalgraphic.onlineresource;
  
    // Use fallback style when graphicfill image hasn't been loaded yet.
    switch (getImageLoadingState(fillImageUrl)) {
      case IMAGE_LOADED:
        return new Fill({
          color: createPattern(graphicFill.graphic),
        });
      case IMAGE_LOADING:
        return imageLoadingPolygonStyle.getFill();
      case IMAGE_ERROR:
        return imageErrorPolygonStyle.getFill();
      default:
        // Load state of an image should be known at this time, but return 'loading' style as fallback.
        return imageLoadingPolygonStyle.getFill();
    }
}

function createPattern(graphic) {
 
    const { image, width, height } = getCachedImage(
      graphic.externalgraphic.onlineresource
    );
  
    let imageRatio = 1;

    const size = graphic && graphic.size? graphic.size : DEFAULT_MARK_SIZE;
    const rotation = graphic && graphic.rotation == null ? 0 : Number(graphic.rotation);


    if (size && height !== size) {
      imageRatio = size / height;
    }
    const cnv = document.createElement('canvas');
    const ctx = cnv.getContext('2d');
    //if (imageRatio === 1) {
    //  return ctx.createPattern(image, 'repeat');
    //}
    const tempCanvas = document.createElement('canvas');
    const tCtx = tempCanvas.getContext('2d');
  
    tempCanvas.width = width * imageRatio;
    tempCanvas.height = height * imageRatio;

    tCtx.globalAlpha = graphic.opacity;
    // prettier-ignore
    tCtx.drawImage(
      image,
      0, 0, width, height,
      0, 0, width * imageRatio, height * imageRatio
    );
    tCtx.restore();

    var svgNamespace = "http://www.w3.org/2000/svg";
    var matrix = document.createElementNS(svgNamespace, "g").getCTM();
    var ptn = ctx.createPattern(tempCanvas, 'repeat');
    ptn.setTransform(matrix.rotate(rotation));

    return ptn;
  }

export default getMarkFillStyle;